import { Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import { styles as mainstyle } from '../../../router/pdfdownload';
import { AbsensiData } from '../../../router/absenhistory';
const styles = StyleSheet.create({
    table: {
        display: 'flex',
        flexDirection: 'column',
        width: 'auto',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#bfbfbf',
        borderCollapse: 'collapse',
        marginTop: 20
    },
    tableRow: {
        margin: 'auto',
        flexDirection: 'row',
    },
    tableColHeader: {
        width: '25%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#bfbfbf',
        backgroundColor: '#eded4e',
        padding: 5,
    },
    tableCol: {
        width: '25%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#bfbfbf',
        padding: 5,
    },
    tableCellHeader: {
        margin: 'auto',
        fontSize: 12,
        fontWeight: 'bold',
    },
    tableCell: {
        margin: 'auto',
        fontSize: 10,
    },
});
const TableAbsen = ({ dataAbsen }: { dataAbsen: AbsensiData[] }) => {
    return (
        <Page size="A4" style={mainstyle.container}>
            <View style={{ width: "100%", textAlign: "center", paddingTop: 20 }}>
                <Text style={[mainstyle.textlg]}>Detail Absensi Karyawan</Text>
            </View>
            <View style={styles.table}>
                {/* Table Header */}
                <View style={styles.tableRow}>
                    <View style={styles.tableColHeader}>
                        <Text style={styles.tableCellHeader}>Tanggal</Text>
                    </View>
                    <View style={styles.tableColHeader}>
                        <Text style={styles.tableCellHeader}>Jam Masuk</Text>
                    </View>
                    <View style={styles.tableColHeader}>
                        <Text style={styles.tableCellHeader}>Jam Pulang</Text>
                    </View>
                    <View style={styles.tableColHeader}>
                        <Text style={styles.tableCellHeader}>Lembur (Jam/Menit)</Text>
                    </View>
                </View>
                {/* Table Rows */}
                {
                    dataAbsen.map((item: AbsensiData, index) => (
                        <View key={index} style={styles.tableRow}>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{item.checkin_date}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{item.checkin_time}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{item.checkout_time}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>
                                    {(item.lembur_hour && item.lembur_hour !== "") 
                                    ? item.lembur_hour.split(":").map((str, idx) => {
                                        const isHour = idx === 0;
                                        const isNonZero = Number(str) > 0;
                                        const unit = isHour ? " Jam " : " Menit";
                                        const label = isNonZero ? str + (isHour ? unit : " Menit") : "";
                                        return label;
                                    }) 
                                    : "-"}

                                </Text>
                            </View>
                        </View>
                    ))
                }
            </View>
        </Page>
    )
}
export default TableAbsen;